import {
    NETWORK_ERROR,
    CLEAR_NETWORK_ERROR,
} from './constants';

export const networkError = payload => ({
    type: NETWORK_ERROR,
    payload: payload,
});

export const clearErrors = () => ({
    type: CLEAR_NETWORK_ERROR,
    payload: {}
});
